{
  "validation": {
    "subjectRequired": "Ämne krävs.",
    "messageRequired": "Meddelandefältet får inte vara tomt.",
    "messageMaxLength": "Meddelandet får vara högst 3000 tecken långt.",
    "categoryRequired": "Meddelandekategori krävs."
  },
  "view": {
    "title": "Alla meddelanden",
    "description": "Vi strävar efter att svara på meddelanden så snabbt som möjligt, vanligtvis inom tre dagar.",
    "messageTitle": "Meddelande",
    "empty": "Inga meddelanden",
    "hideConversation": "Dölj konversation",
    "showConversation": "Visa konversation",
    "sendNewMessage": "Nytt meddelande",
    "newBadge": "Ny",
    "replyToMessage": "Svara på meddelande",
    "reply": "Svara",
    "previous": "Alla meddelanden"
  },
  "form": {
    "replyPrefix": "RE:",
    "subject": "Ämne",
    "category": "Meddelandekategori",
    "selectCategory": "Välj vad ditt ärende gäller",
    "noCategory": "Ingen kategori",
    "categoryLoadError": "Meddelandekategorierna kunde inte laddas. Försök igen.",
    "retry": "Försök igen",
    "message": "Meddelande",
    "attachments": "Bilagor",
    "send": "Skicka",
    "cancel": "Avbryt",
    "errorTitle": "Ett fel uppstod vid sändning av meddelandet.",
    "successTitle": "Meddelandet skickades!",
    "visibleToAllParticipants": "Ditt svar syns för alla deltagare i konversationen."
  }
}
